import AppBar from "@material-ui/core/AppBar";
import Collapse from "@material-ui/core/Collapse";
import IconButton from "@material-ui/core/IconButton";
import InputBase from "@material-ui/core/InputBase";
import Paper from "@material-ui/core/Paper";
import { createStyles, fade, makeStyles } from "@material-ui/core/styles";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import CloseIcon from "@material-ui/icons/Close";
import SearchIcon from "@material-ui/icons/Search";
import React, { useEffect } from "react";
import { Rnd } from "react-rnd";
import Results from "./Results";
import Tooltip from "@material-ui/core/Tooltip";
import { Button, MenuItem, Select } from "@material-ui/core";
import { useActions, useValues } from "kea";
import Fuse from "fuse.js";

import vehiclelogic from "src/store/vehicle";
import { preferenceslogic, maplogic } from "src/store/global";
import profilelogic from "src/store/profile";

const useStyles = makeStyles((theme) =>
	createStyles({
		root: {
			width: "100%",
			// height: "100%",
			minHeight: 0,
			flexGrow: 1,
		},
		container: {
			maxHeight: 440,
		},
		search: {
			position: "relative",
			borderRadius: theme.shape.borderRadius,
			backgroundColor: fade(theme.palette.common.white, 0.15),
			"&:hover": {
				backgroundColor: fade(theme.palette.common.white, 0.25),
			},
			marginRight: theme.spacing(2),
			marginLeft: 0,
			width: "100%",
			[theme.breakpoints.up("sm")]: {
				marginLeft: theme.spacing(3),
				width: "auto",
			},
		},
		searchIcon: {
			padding: theme.spacing(0, 2),
			height: "100%",
			position: "absolute",
			pointerEvents: "none",
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
		},
		inputRoot: {
			color: "inherit",
		},
		inputInput: {
			padding: theme.spacing(1, 1, 1, 0),
			// vertical padding + font size from searchIcon
			paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
			transition: theme.transitions.create("width"),
			width: "100%",
			[theme.breakpoints.up("md")]: {
				width: "20ch",
			},
		},
	}),
);

const useStyles2 = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
	},
	menuButton: {
		marginRight: theme.spacing(2),
	},
	title: {
		flexGrow: 1,
		display: "none",
		[theme.breakpoints.up("sm")]: {
			display: "block",
		},
	},
	search: {
		position: "relative",
		borderRadius: theme.shape.borderRadius,
		backgroundColor: fade(theme.palette.common.white, 0.15),
		"&:hover": {
			backgroundColor: fade(theme.palette.common.white, 0.25),
		},
		marginLeft: 0,
		width: "100%",
		[theme.breakpoints.up("sm")]: {
			marginLeft: theme.spacing(1),
			width: "auto",
		},
	},
	searchIcon: {
		padding: theme.spacing(0, 2),
		height: "100%",
		position: "absolute",
		pointerEvents: "none",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	inputRoot: {
		color: "inherit",
	},
	inputInput: {
		padding: theme.spacing(1, 1, 1, 0),
		// vertical padding + font size from searchIcon
		paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
		transition: theme.transitions.create("width"),
		width: "100%",
		[theme.breakpoints.up("sm")]: {
			width: "15ch",
			"&:focus": {
				width: "20ch",
			},
		},
	},
	expand: {
		color: "white",
	},
	expandOpen: {
		color: "white",
	},
}));

const columns = [
	{
		field: "name",
		headerName: "Name",
		width: 230,
		align: "left",
	},
	{
		field: "info",
		headerName: "Status",
		width: 95,
		align: "left",
	},
	{
		field: "actions",
		headerName: "Actions",
		align: "left",
		sortable: false,
		width: 190,
	},
];

export default function VehiclePanel() {
	const classes = useStyles();
	const classes2 = useStyles2();

	const { profile } = useValues(profilelogic);
	// const { fetchAll: fetchAllGroups } = useActions(grouplogic);

	const { vehicles } = useValues(vehiclelogic);
	const { fetchAll } = useActions(vehiclelogic);

	const { vehicle, drawer } = useValues(preferenceslogic);
	const { setVehicle } = useActions(preferenceslogic);

	const { vehicles: vehiclesOnMap } = useValues(maplogic);
	const { addOne, removeOne } = useActions(maplogic);

	const [showAllStatus, setShowAllStatus] = React.useState(false);
	const [filtered, setFiltered] = React.useState(vehicles);
	const [search, setSearch] = React.useState("");
	const [groupfilter, setGroupFilter] = React.useState("All");

	useEffect(() => {
		vehicles ?? fetchAll();
		// groups ?? fetchAllGroups();
	}, []);

	useEffect(() => {
		if (!vehicles) return;
		if (search === "") {
			let groupfiltered = [];
			if (groupfilter !== "All") {
				groupfiltered =
					vehicles?.filter((item) =>
						item?.groups?.map((g) => g._id).includes(groupfilter),
					) || [];
			} else {
				groupfiltered = vehicles;
			}
			setFiltered(groupfiltered);
		} else {
			let groupfiltered = [];
			if (groupfilter !== "All") {
				groupfiltered =
					vehicles?.filter((item) =>
						item?.groups?.map((g) => g._id).includes(groupfilter),
					) || [];
			} else {
				groupfiltered = vehicles;
			}
			const fuse = new Fuse(groupfiltered, {
				keys: ["name", "registration_number", "tracker.serial"],
				threshold: 0.0,
				ignoreLocation: true,
			});
			let found = fuse.search(search);
			found = found.map((item) => {
				item.item.refIndex = item.refIndex;
				return item.item;
			});
			setFiltered(found);
		}
	}, [vehicles]);

	useEffect(() => {
		if (!vehicles) return;
		if (search === "") {
			let groupfiltered = [];
			if (groupfilter !== "All") {
				groupfiltered = vehicles.filter((item) =>
					item?.groups?.map((g) => g._id).includes(groupfilter),
				);
			} else {
				groupfiltered = vehicles;
			}
			setFiltered(groupfiltered);
		} else if (vehicles) {
			let groupfiltered = [];
			if (groupfilter !== "All") {
				groupfiltered = vehicles.filter((item) =>
					item?.groups?.map((g) => g._id).includes(groupfilter),
				);
			} else {
				groupfiltered = vehicles;
			}
			const fuse = new Fuse(groupfiltered, {
				keys: ["name", "registration_number", "tracker.serial"],
				threshold: 0.0,
				ignoreLocation: true,
			});
			let found = fuse.search(search);
			found = found.map((item) => {
				item.item.refIndex = item.refIndex;
				return item.item;
			});
			setFiltered(found);
			setVehicle({ ...vehicle, expand: true });
		}
	}, [search, groupfilter]);

	const handle_search = (e) => setSearch(e.target.value);

	const handleExpandClick = () => {
		setVehicle({ ...vehicle, expand: !vehicle.expand });
	};

	const handleOnDrag = (e) => {
		setVehicle({
			...vehicle,
			position: {
				x: e.layerX - e.offsetX - (drawer.expand ? 220 : 72),
				y: e.layerY - e.offsetY - 48,
			},
		});
	};

	const includes_mobile_vehicles_on_map = (mobile_vehicle) => {
		let flag = vehiclesOnMap.find((item) => {
			return item._id === mobile_vehicle._id;
		});
		if (flag === undefined) {
			return false;
		}
		return true;
	};

	const handleShowAllButton = () => {
		let newShowAllStatus = !showAllStatus;
		setShowAllStatus(newShowAllStatus);
		if (!vehiclesOnMap.length) {
			if (filtered.length) {
				if (filtered.length > 100) {
					window.alert(
						"Cannot add more than 100 vehicles to the map. Please narrow down the search criteria.",
					);
					return;
				}
				filtered.forEach((item) => {
					// console.log(item);
					if (item.tracker && item.tracker.status.length > 0) {
						if (!includes_mobile_vehicles_on_map(item)) {
							addOne(item);
						}
					}
				});
			} else {
				if (vehicles.length > 100) {
					window.alert(
						"Cannot add more than 100 vehicles to the map. Please narrow down the search criteria.",
					);
					return;
				}
				vehicles.forEach((item) => {
					// console.log(item);
					if (item.tracker && item.tracker.status.length > 0) {
						if (!includes_mobile_vehicles_on_map(item)) {
							addOne(item);
						}
					}
				});
			}
		} else {
			vehicles.forEach((item) => {
				// console.log(item);
				if (item.tracker && item.tracker.status.length > 0) {
					if (includes_mobile_vehicles_on_map(item)) {
						removeOne(item);
					}
				}
			});
		}
	};

	return (
		<Rnd
			default={{
				x: vehicle.position.x,
				y: vehicle.position.y,
				width: 600,
			}}
			enableResizing={false}
			bounds={"#panelHolder"}
			onDragStop={handleOnDrag}
			cancel={"#rnd-ignore-drag"}
		>
			<Paper elevation={0} className={classes.root}>
				<div className={classes2.root}>
					<AppBar
						position="static"
						style={{
							height: "110px",
						}}
					>
						<div
							style={{
								display: "flex",
								justifyContent: "space-between",
							}}
						>
							<div
								style={{
									paddingLeft: "15px",
									paddingTop: "10px",
								}}
							>
								<Typography className={classes2.title} variant="h6" noWrap>
									Vehicles
								</Typography>
								<Typography className={classes2.title} variant="caption" noWrap>
									You can click and drag this panel.
								</Typography>
							</div>
							<div id={"rnd-ignore-drag"}>
								<Tooltip title="Close this panel">
									<IconButton
										onClick={() =>
											setVehicle({
												...vehicle,
												show: !vehicle.show,
												position: { x: 10, y: 180 },
											})
										}
										aria-label="less"
									>
										<Typography style={{ color: "white" }}>Close</Typography>
										<CloseIcon htmlColor="white" />
									</IconButton>
								</Tooltip>
							</div>
						</div>
						<Toolbar
							variant="dense"
							style={{
								paddingLeft: "0px",
								paddingRight: "0px",
								display: "flex",
								alignContent: "center",
							}}
						>
							<div
								id={"rnd-ignore-drag"}
								className={classes.search}
								style={{
									width: "300px",
								}}
							>
								<div className={classes.searchIcon}>
									<SearchIcon />
								</div>
								<InputBase
									fullWidth
									placeholder="Vehicle Search…"
									classes={{
										root: classes.inputRoot,
										input: classes.inputInput,
									}}
									onChange={handle_search}
									inputProps={{ "aria-label": "search" }}
								/>
							</div>
							<div id={"rnd-ignore-drag"}>
								<Select
									labelId="group-select-label"
									id="group-select"
									label="Age"
									defaultValue={"All"}
									autoWidth
									style={{
										padding: "0px",
										color: "white",
										width: "100px",
										marginRight: "10px",
									}}
									variant="outlined"
									SelectDisplayProps={{
										style: { padding: "10px 10px" },
									}}
									onChange={(e) => {
										setGroupFilter(e.target.value);
									}}
								>
									<MenuItem value={"All"}>All</MenuItem>
									{profile.groups?.map((group, index) => (
										<MenuItem value={group._id}>{group.name}</MenuItem>
									))}
								</Select>
							</div>
							<div id={"rnd-ignore-drag"}>
								<Tooltip title="Show all the Vehicles on the map">
									<Button
										variant="contained"
										color="primary"
										onClick={handleShowAllButton}
										endIcon={
											search && !vehiclesOnMap.length ? <SearchIcon /> : null
										}
										size="xs"
										style={{ width: "105px" }}
									>
										{vehiclesOnMap.length > 0
											? "Hide All"
											: `Show ${search && !vehiclesOnMap.length ? "" : "All"}`}
									</Button>
								</Tooltip>
							</div>
							<div id={"rnd-ignore-drag"}>
								{vehicle.expand ? (
									<Tooltip title="Panel Collapse">
										<IconButton
											onClick={handleExpandClick}
											aria-label="less"
											className={classes.margin}
										>
											<Typography style={{ color: "white" }}>
												Collapse
											</Typography>
											<ExpandLessIcon htmlColor="white" />
										</IconButton>
									</Tooltip>
								) : (
									<Tooltip title="Panel Expand">
										<IconButton
											onClick={handleExpandClick}
											aria-label="more"
											className={classes.margin}
										>
											<Typography style={{ color: "white" }}>Expand</Typography>
											<ExpandMoreIcon htmlColor="white" />
										</IconButton>
									</Tooltip>
								)}
							</div>
						</Toolbar>
					</AppBar>
				</div>
				<Collapse
					id={"rnd-ignore-drag"}
					in={vehicle.expand}
					timeout="auto"
					unmountOnExit
					style={{ cursor: "default" }}
				>
					<Results rows={filtered} columns={columns} />
				</Collapse>
			</Paper>
		</Rnd>
	);
}
